// extracted by mini-css-extract-plugin
export default {"subBusinessId":"competitor-list_subBusinessId__+crK2","imageSize":"competitor-list_imageSize__uiu6R","viewPhoto":"competitor-list_viewPhoto__0PMHw"};